export const queryKey = {
    justifications: () => ['justifications'],
};
